import {React,  useState ,useEffect,useRef} from "react";
import { useNavigate  } from "react-router-dom";
import './idproof.css';
import 'bootstrap/dist/css/bootstrap.css';
import KycShell, { BrowserOnlyWarning } from '../components/KycShell';


const IdproofType = () => {
	const inputRef = useRef(null);
	const brandname = localStorage.getItem('brandname');
	const brandlogo = localStorage.getItem('brandlogo');
	const navigate = useNavigate();
	const [isMobile, setIsMobile] = useState(false);
	const checkIfMobile = () => {
		if (window.innerWidth <= 768) {
		  return true;
		}
		return false;
	  };
	  const updateMedia = () => {
		setIsMobile(checkIfMobile());
	  };

	  useEffect(() => {
		updateMedia();
		window.addEventListener('resize', updateMedia);
		return () => {
		  window.removeEventListener('resize', updateMedia);
		};
	  }, []);


	const apicountryname = localStorage.getItem('setapicountryname');
	const passport = localStorage.getItem('setapipassport');
	const idcard = localStorage.getItem('setidcard');
	const isIdCard = localStorage.getItem('isIdCard');
	const driverlicense = localStorage.getItem('setdriverlicense');
	const permitresidence = localStorage.getItem('setpermitresidence');

	//console.log("isIdCard "+ isIdCard);

	localStorage.removeItem('front_back');
	const nextpage = (e) => {
		if (e === 'Passport')
		{
		  localStorage.setItem('front_back', '0');
		  localStorage.setItem('id_image', './icon/example.png');
		  localStorage.removeItem('id_image_back');
		} else if (e === 'Driver License') {
		  localStorage.setItem('front_back', localStorage.getItem('driver_license_type'));
		  localStorage.setItem('id_image', './icon/driver_address.png');
		  localStorage.setItem('id_image_back', './icon/driver_address.png');
		} else if (e === 'ID Proof') {
		  localStorage.setItem('front_back', localStorage.getItem('idcard_type'));
		  localStorage.setItem('id_image', './icon/driver_address.png');
		  localStorage.setItem('id_image_back', '../icon/driver_address.png');
		} else if (e === 'Residence Permit') {
		  localStorage.setItem('front_back', localStorage.getItem('permit_residence_type'));
		  localStorage.setItem('id_image', './icon/ResidencePermit-front.png');
		  localStorage.setItem('id_image_back', './icon/ResidencePermit-back.png');
		}

		localStorage.setItem('setdocumenttitle', e);
		navigate('/Passport');
	  };


    useEffect(() => {
		let uuids = localStorage.getItem('uuid');
		if(uuids === null)
		{
			navigate('/');
		}
    }, [])
	useEffect(() => {

	  }, [isMobile]);
    return(
	<>
		{!isMobile && <BrowserOnlyWarning />}

		{isMobile && (
			<KycShell step={2} brandName={brandname}>
				<div className="kyc-card">
					<div className="kyc-card__eyebrow">Document type</div>
					<h1 className="kyc-card__title">Choose your document type</h1>

					<div className="kyc-doc-country">
						<span className="kyc-doc-country__label">Issued by</span>
						<span>{apicountryname}</span>
					</div>

					<p className="kyc-card__subtitle" style={{ marginTop: 4 }}>
						Accepted documents
					</p>

					<div className="kyc-doc-grid">
						{passport == 1 && (
							<div className="kyc-doc-card idproof" onClick={() => nextpage('Passport')}>
								<div className="kyc-doc-card__icon">
									<i className="fa fa-book" aria-hidden="true"></i>
								</div>
								<div style={{ flex: 1, minWidth: 0 }}>
									<p className="kyc-doc-card__title">Passport</p>
									<p className="kyc-doc-card__desc">Passport photo page</p>
								</div>
								<span className="kyc-doc-card__arrow">
									<i className="fa fa-chevron-right" aria-hidden="true"></i>
								</span>
							</div>
						)}

						{isIdCard === 1 && idcard === 1 && (
							<div className="kyc-doc-card idproof" onClick={() => nextpage('ID Proof')}>
								<div className="kyc-doc-card__icon">
									<i className="fa fa-id-card" aria-hidden="true"></i>
								</div>
								<div style={{ flex: 1, minWidth: 0 }}>
									<p className="kyc-doc-card__title">ID Proof</p>
									<p className="kyc-doc-card__desc">Front &amp; back photo</p>
								</div>
								<span className="kyc-doc-card__arrow">
									<i className="fa fa-chevron-right" aria-hidden="true"></i>
								</span>
							</div>
						)}

						{permitresidence == 1 && (
							<div className="kyc-doc-card idproof" onClick={() => nextpage('Residence Permit')}>
								<div className="kyc-doc-card__icon">
									<i className="fa fa-id-badge" aria-hidden="true"></i>
								</div>
								<div style={{ flex: 1, minWidth: 0 }}>
									<p className="kyc-doc-card__title">Residence Permit</p>
									<p className="kyc-doc-card__desc">Upload address proof</p>
								</div>
								<span className="kyc-doc-card__arrow">
									<i className="fa fa-chevron-right" aria-hidden="true"></i>
								</span>
							</div>
						)}
					</div>
				</div>
			</KycShell>
		)}
	</>
	);
}
export default IdproofType;
